// extracted by mini-css-extract-plugin
export default {"p":"_9d224e4f18 _76a31475cd _80f0d1b362","clr":"_78d126dace","dls":"_7f9a727075"};